/** Keys supported by the backend user preferences API. */
export const USER_PREF_KEYS = {
  theme: 'theme',
  locale: 'locale',
  language: 'language',
  dateFormat: 'dateFormat',
  timezone: 'timezone',
  itemsPerPage: 'itemsPerPage',
};

/** Fallback values when the API has not loaded yet. */
export const DEFAULT_USER_PREFERENCES = {
  [USER_PREF_KEYS.theme]: 'light',
  [USER_PREF_KEYS.locale]: 'en-US',
  [USER_PREF_KEYS.language]: 'en',
  [USER_PREF_KEYS.dateFormat]: 'yyyy-MM-dd',
  [USER_PREF_KEYS.timezone]: 'UTC',
  [USER_PREF_KEYS.itemsPerPage]: '25',
};

export const PREFERENCE_SECTIONS = [
  {
    id: 'appearance',
    title: 'Appearance',
    fields: [{ key: USER_PREF_KEYS.theme, label: 'Theme' }],
  },
  {
    id: 'language-region',
    title: 'Language & region',
    fields: [
      { key: USER_PREF_KEYS.language, label: 'Language' },
      { key: USER_PREF_KEYS.locale, label: 'Region (locale)' },
    ],
  },
  {
    id: 'dates-time',
    title: 'Dates & time',
    fields: [
      { key: USER_PREF_KEYS.dateFormat, label: 'Date format' },
      {
        key: USER_PREF_KEYS.timezone,
        label: 'Time zone',
        description:
          'Used for how dates and times are shown, and for filters like Today.',
      },
    ],
  },
  {
    id: 'lists',
    title: 'Lists',
    fields: [{ key: USER_PREF_KEYS.itemsPerPage, label: 'Items per page' }],
  },
];

/**
 * Merge API preferences with defaults so the UI always has a full object.
 */
export function normalizeUserPreferences(preferences) {
  return {
    ...DEFAULT_USER_PREFERENCES,
    ...(preferences && typeof preferences === 'object' ? preferences : {}),
  };
}

export function parseItemsPerPage(value) {
  const parsed = parseInt(String(value), 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : parseInt(DEFAULT_USER_PREFERENCES.itemsPerPage, 10);
}
